<template>
  <div class="SeniorResultPage">
    <div
      style="display: flex; align-items: stretch; position: relative"
      :style="{ flexDirection: this.hasSearch ? 'row' : 'column' }"
    >
      <div class="DropBox">
        <div class="SeniorResultPage_keywords" v-if="this.isShow">
          <div class="options_second">
            <el-input
              placeholder="请输入内容"
              v-model="first_query"
              class="input-with-select"
              suffix-icon="el-icon-search"
              maxlength="100"
            >
              <el-select v-model="select1" slot="prepend" placeholder="请选择">
                <el-option
                  v-for="item in selectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-input>
          </div>
          <el-button type="primary" @click="() => advancedSearch()" 
            >检索</el-button
          >
        </div>
        <div class="advanced_search" v-else>
          <div class="keywordsBox" style="margin-top: 15px">
            <!-- <div style="border: 0" class="options_first"></div> -->
            <div class="options_second">
              <el-input
                placeholder="请输入内容"
                v-model="first_query"
                class="input-with-select"
                suffix-icon="el-icon-search"
                maxlength="100"
              >
                <el-select
                  v-model="select1"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in selectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-input>
            </div>
          </div>

          <div class="keywordsBox" style="margin-top: 15px">
            <!-- <div style="border: 0" class="options_first">
              <el-select v-model="value1" placeholder="请选择">
                <el-option
                  v-for="item in conditions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="options_second">
              <el-input
                placeholder="请输入内容"
                v-model="second_query"
                class="input-with-select"
                suffix-icon="el-icon-search"
                maxlength="100"
              >
                <el-select
                  v-model="select2"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in selectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-input>
            </div>
          </div>
          <div class="keywordsBox" style="margin-top: 15px">
            <!-- <div style="border: 0" class="options_first">
              <el-select v-model="value2" placeholder="请选择">
                <el-option
                  v-for="item in conditions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="options_second">
              <el-input
                placeholder="请输入内容"
                v-model="third_query"
                class="input-with-select"
                suffix-icon="el-icon-search"
                maxlength="100"
              >
                <el-select
                  v-model="select3"
                  slot="prepend"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in selectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-input>
            </div>
          </div>
          <div class="dateOrLocalBox" style="margin-top: 15px">
            <div>
              <span style="margin-right: 20px">时间范围:</span>
              <el-date-picker
                v-model="date_start"
                type="datetime"
                placeholder="选择起始时间"
              >
              </el-date-picker>
              <el-date-picker
                style="margin-left: 20px"
                v-model="date_end"
                type="datetime"
                placeholder="选择终止时间"
              >
              </el-date-picker>
            </div>
            <div style="margin-left: 20px">
              <span style="margin-right: 20px">数据来源:</span>
              <el-select placeholder="请选择" v-model="location">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="btnBox">
            <div class="btn" @click="reset">重置条件</div>
            <div class="btn" @click="advancedSearch">检索</div>
          </div>
        </div>
        <el-button
          type="button"
          class="el-icon-d-arrow-left"
          :class="{ down: this.isUp, up: !this.isUp }"
          circle
          size="mini"
          @click="changeSearch"
        ></el-button>
      </div>
      <div
        v-show="this.reminderVisible"
        class="reminder"
        :class="{
          'reminder-right': this.hasSearch,
        }"
      >
        <h1>高级检索说明</h1>
        <div style="overflow: auto; flex: 1">
          <span
            >全文检索的领域可以检索海洋信息、电磁空间、军事领域。</span
          >
          <span>
            高级检索支持同一检索项内多个检索词的组合运算，检索框内输入的内容不得超过100个字符。
          </span>
        </div>
      </div>
    </div>

    <div class="result_nav" v-if="isShowInfo">
      <span class="result_nav_center">结果分析</span>
      <span class="result_nav_right">
        <span>排序：</span>
        <span @click="timeSort" :class="{ blue: activeSort == 'timeSort' }"
          >时间<i
            v-if="activeSort == 'timeSort'"
            :class="{
              'el-icon-bottom': !this.searchData.order_id,
              'el-icon-top': this.searchData.order_id,
            }"
          ></i
        ></span>
        <span
          @click="relevanceSort"
          :class="{ blue: activeSort == 'relevanceSort' }"
          >相关度<i
            v-if="activeSort == 'relevanceSort'"
            :class="{
              'el-icon-bottom': !this.searchData.order_id,
              'el-icon-top': this.searchData.order_id,
            }"
          ></i
        ></span>
        <span
          @click="synthesisSort"
          :class="{ blue: activeSort == 'synthesisSort' }"
          >综合<i
            v-if="activeSort == 'synthesisSort'"
            :class="{
              'el-icon-bottom': !this.searchData.order_id,
              'el-icon-top': this.searchData.order_id,
            }"
          ></i
        ></span>
        <!-- <span
          >显示
          <select name="" id="" class="dropdown-menu-number" v-model="pageSize" @change="pageSizeChange">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
          </select></span
        > -->
      </span>
    </div>
    <div
      v-if="isShowInfo"
      v-loading="loading"
      element-loading-text="拼命加载中, 请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgb(233 233 233)"
      class="result-content-contianer"
    >
      <div class="result_content">
        <!-- <div
          v-for="(i, inx) in newsData"
          :key="inx"
          class="result_content_list"
          @click="() => handleSelectedNews(i.date, i.text)"
        >
          <div style="display: flex; justify-content: space-between">
            <span></span>
            <span>{{ i.date }}</span>
          </div>
          <div style="line-height: 24px" :class="'words' + inx">
            {{ i.text }}
          </div>
        </div>
        <div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager,next, jumper"
          :total="total"
          style="text-align: center"
        >
        </el-pagination>
      </div> -->
      <InformationList
          :information-data="newsData"
          :scale="{ width: '100%' }"
          :search-name="lastSearchName"
        />
        <el-pagination
          style="text-align: center"
          small
          @current-change="handlePageChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <InfoWindow :title="'相关信息'" class="content-info" @close="() => this.isShowDetail = false" v-show="isShowDetail">
        <span class="time-info">{{ `时间:${timeInfo}` }}</span>
        <span class="text-info" v-html="textInfo.toString()"></span>
      </InfoWindow>
    </div>
  </div>
</template>
<script>
// import ckmAi from "@/services/ckmAi.js";
import InfoWindow from '@/views/Search/DetailPage1.vue'
import InformationList from "@/components/InformationList";
import api from '@/services/api'
export default {
  name: "SeniorResultPage",
  components: {
    InfoWindow,
    InformationList
  },

  data() {
    return {
      lastSearchName:"",
      loading: true,
      pageSize: 10,
      currentPage: 1,
      activeSort: "",
      newsData: [],
      isShow: false,
      isShowInfo: false,
      total: 0,
      options: [
        {
          value: "微博",
          label: "微博",
        },
        {
          value: "微信公众号",
          label: "微信公众号",
        },
        {
          value: "新浪新闻",
          label: "新浪新闻",
        },
        {
          value: "头条",
          label: "头条",
        },
        {
          value: "知乎",
          label: "知乎",
        },
      ],
      select1: "关键词",
      select2: "主题", // domain_id  例如1海洋信息 2电磁空间 3军事领域
      select3: "领域",
      selectOptions: [
        {
          value: "领域",
          label: "领域",
        },
        {
          value: "关键词",
          label: "关键词",
        },
        {
          value: "主题",
          label: "主题",
        },
      ],
      isUp: true,
      date_start: null, // 开始时间
      date_end: null, // 结束时间
      location: "微博", // 数据来源
      first_query: "", // 关键字1
      second_query: "", // 关键字2
      third_query: "", // 关键字3
      hasSearch: false,
      timeInfo: '',
      textInfo: '',
      isShowDetail: false
    };
  },
  computed: {
    searchData() {
      return {
        date_start: this.formatDateTime(this.date_start), // 开始时间
        date_end: this.formatDateTime(this.date_end), // 结束时间
        location: this.location, // 地区
        first_query: { text: this.first_query }, // 关键字1
        second_query: { condition: this.value1, text: this.second_query }, // 关键字2
        third_query: { condition: this.value2, text: this.third_query }, // 关键字3
        page: 1,
        size: 10,
        order: "relevance",
        order_id: 0,
      };
    },
    reminderVisible() {
      return !this.hasSearch || !this.isShow;
    },
  },

  methods: {
    // pageSizeChange() {
    //   this.seniorSearch();
    // },
    timeSort() {
      this.activeSort = "timeSort";
      // datetime
      this.order = "0";
      this.searchData.order_id = Number(!this.searchData.order_id);
      this.advancedSearch();
    },
    relevanceSort() {
      this.activeSort = "relevanceSort";
      // relevance
      this.searchData.order_id = Number(!this.searchData.order_id);
      this.order = "1";
      this.advancedSearch();
    },
    synthesisSort() {
      this.activeSort = "synthesisSort";
      // comprehensive
      this.searchData.order_id = Number(!this.searchData.order_id);
      this.order = "2";
      this.advancedSearch();
    },
    handleSizeChange() {},
    handleCurrentChange(currentPage) {
      this.searchData.page = currentPage;
      this.seniorSearch();
    },
    seniorSearch(data) {
      if (data) {
        this.Search(data);
      } else {
        this.Search(this.searchData);
      }
    },
    // Search(data) {
    //   this.isShowInfo = true;
    //   this.isShow = true;
    //   this.isUp = !this.isUp;
    //   if (this.isShow) {
    //     this.isUp = false;
    //   }
    //   this.loading = true;
    //   this.hasSearch = true;
    //   // ckmAi.searchAdvancedSearch(data).then((res) => {
    //   //   if (res.data.code == 200) {
    //   //     this.newsData = res.data.data.query_result;
    //   //     this.total = res.data.data.nums;

    //   //     // console.log(res.data.data.query_result);
    //   //     setTimeout(() => {
    //   //       res.data.data.query_result.forEach((item, index) => {
    //   //         // let word = this.keywords.first_query.text;
    //   //         // const regEx = new RegExp(word, "g");
    //   //         // item.text = item.text.replace(
    //   //         //   regEx,
    //   //         //   '<span style="color:red;">' + word + "</span>"
    //   //         // );
    //   //         let text = "";
    //   //         for (let i = 0; i < item.text.length; i++) {
    //   //           const element = item.text[i];
    //   //           text += element;
    //   //         }
    //   //         let dom = document.querySelector(".words" + index);
    //   //         dom && (dom.innerHTML = text);
    //   //       });
    //   //       this.$message({
    //   //         type: "success",
    //   //         message: "检索成功",
    //   //       });
    //   //       this.loading = false;
    //   //     });
    //   //   } else {
    //   //     this.loading = false;
    //   //     this.$message({
    //   //       type: "error",
    //   //       message: res.data.msg,
    //   //     });
    //   //   }
    //   // });
    // },
    reset() {
      this.first_query = "";
      this.second_query = "";
      this.third_query = "";
      this.location = "";
      this.date_start = null;
      this.date_end = null;
      this.value1 = "AND";
      this.value2 = "AND";
    },
    changeSearch() {
      this.isShow = !this.isShow;
      this.isUp = !this.isUp;
    },
    formatDateTime(timestamp) {
      if (!timestamp) {
        return null;
      } else {
        var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D = date.getDate() + " ";
        var h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        var m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // return Y + M + D + h + m + s;
        if (Y + M + D + h + m + s == "NaN-NaN-NaN NaN:NaN:NaN") {
          return null;
        } else {
          return Y + M + D + h + m + s;
        }
      }
    },
    advancedSearch() {
      // const data = this.searchData;
      // if (this.searchData.first_query.text) {
      //   this.seniorSearch(data);
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: "关键词必选",
      //   });
      // }
      if (!this.searchData.first_query) {
       this.$message({
          type: "error",
          message: "关键词必选",
        });
        return
      }
     
      this.isShowInfo = true;
      this.isShow = true;
      this.isUp = !this.isUp;
      if (this.isShow) {
        this.isUp = false;
      }
      this.loading = true;
      this.hasSearch = true;

      this.lastSearchName= this.first_query
       if(!this.activeSort){ // 默认没有点击排序
         var params = {
              page_size: this.pageSize,
              page_to: this.currentPage,
              search: this.first_query,
              search2: this.second_query,
              date_start: this.formatDateTime(this.date_start), // 开始时间
              date_end: this.formatDateTime(this.date_end), // 结束时间
          }
        }else{
          var params = {
            order_option:Number(this.order), // 类型
            order_id:Number(this.searchData.order_id), // 升降
            page_size: this.pageSize,
            page_to: this.currentPage,
            search: this.first_query,
            search2: this.second_query,
            date_start: this.formatDateTime(this.date_start), // 开始时间
            date_end: this.formatDateTime(this.date_end), // 结束时间
        }
      }
      api.region_information.detail("",{params}).response.then((res) => res.data)
        .then((res) => { 
          if(res.code == 200){
            this.newsData = [];
          const { records } = res.data;
          if(records.length<1){
            this.$message.info("暂无该信息!")
          }
          records.forEach((b) => {
            this.newsData.push({
              cardTitle: b.information.title,
              cardContent: b.information.short_content,
              href: b.information.link,
              the_time: b.information.the_time,
            });
          });
          this.total = res.data.total_records
          this.loading = false;
          }
        })
    },
    handlePageChange(currentPage) {
      this.currentPage = currentPage;
    },
    // handleSelectedNews(timeInfo, textInfo) {
    //   this.timeInfo = timeInfo
    //   this.textInfo = textInfo
    //   this.isShowDetail = true
    // }
  },
};
</script>
<style  lang='scss' scope>
$fontColor: #000;
$border: 1px solid #e4e4e4;
.SeniorResultPage .blue {
  color:yellow !important;
}
.el-pager,
  .el-pager li {
    background-color: transparent !important;
    color: rgb(185, 179, 179) !important;
  }
  .el-pager .active {
    background-color: rgba($color: #fff, $alpha: 0.3) !important;
    // color: #3951b3;
    color: #eee !important;
  }
  .el-pagination__total {
    color: rgb(185, 179, 179) !important;
  }
  .el-pagination__jump {
    color: rgb(185, 179, 179) !important;
    .el-pagination__editor.el-input .el-input__inner {
      // height: 1.5em ;
      background-color: transparent !important;
      color:#eee !important;
    }
  }
.SeniorResultPage {
  overflow: auto;
  padding-top: 20px;
  // width: 100vw;
  height: calc(100% - 81.33px);
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  align-items: center;
  .el-loading-spinner {
    top: 30%;
  }
  span {
    color: #fff;
  }
  .DropBox {
    position: relative;
    // box-shadow: 0 5px 5px #cdcdcd;
    border: var(--border-green2);
    background-color: var(--background-color-input);
    // }
    .up {
      color: var(--font-color-green);
      border: var(--border-green2);
      background-color: rgba($color: #fff, $alpha: 0.8);
      position: absolute;
      transform: translateY(50%) rotate(-90deg);
      bottom: 0;
      left: 50%;
    }
    .down {
      color: var(--font-color-green);
      border: var(--border-green2);
      background-color: rgba($color: #fff, $alpha: 0.8);
      position: absolute;
      transform: translateY(50%) rotate(90deg);
      bottom: 0;
      left: 50%;
    }
  }
  .reminder {
    // box-shadow: 0 5px 5px #cdcdcd;
    border: var(--border-green2);
    background-color: var(--background-color-input);
    width: 900px;

    line-height: 1.5;
    padding: 10px;
    margin-top: 30px;
    h1 {
      padding-left: 20px;
      padding-bottom: 10px;
      font-size: 24px;
      color: white;
      font-weight: normal;
      border-bottom: var(--border-green2);
    }
    span {
      padding-top: 10px;
      display: inline-block;
      text-indent: 1em;
      line-height: 1.5;
      font-size: 18px;
      color: white;
    }
  }
  .reminder-right {
    position: absolute;
    right: -10px;
    transform: translateX(100%);
    width: 250px;
    box-sizing: border-box;
    height: 100%;
    margin-top: 0px;
    display: flex;
    flex-direction: column;
  }

  .SeniorResultPage_keywords {
    width: 880px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    .options_second {
      .el-select .el-input {
        width: 130px;
      }
      .input-with-select .el-input-group__prepend {
        background-color: #fff;
      }
      .el-input-group__prepend {
        .el-input__inner {
          width: 130px;
        }
      }
      .el-input__inner {
        width: 600px;
      }
    }
    .el-button--primary {
      // background-color: #0f5de5;
      border-radius: 0px;
      box-shadow: 0 0 1.5em rgba(188, 230, 236, 0.5) inset;
      background-color: rgb(8, 14, 32);
      // border-color:  rgb(8, 14, 32);
      span {
        color: #fff;
      }
    }
  }
  .advanced_search {
    width: 920px;

    .keywordsBox {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 30px;
      .options_first {
        vertical-align: top;
        text-align: center;
        line-height: 40px;
        margin-left: 20px;
        display: inline-block;
        width: 110px;
        height: 40px;
      }
      .options_second {
        .el-select .el-input {
          width: 130px;
        }
        .input-with-select .el-input-group__prepend {
          background-color: #fff;
        }
        .el-input-group__prepend {
          .el-input__inner {
            width: 130px;
          }
        }
        .el-input__inner {
          width: 600px;
        }
      }
    }
    .dateOrLocalBox {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      min-width: 900px;
      align-items: center;

      .el-input__inner {
        background: transparent;
        color: white;
      }

      span {
        font-size: 14px;
        color: white;
      }
    }
    .btnBox {
      margin-top: 20px;
      text-align: -webkit-center;
      border-top: var(--border-green2);
      display: flex;
      flex-direction: row;
      justify-content: center;
      min-width: 900px;
      align-items: center;
      color: #fff;
      .btn {
        cursor: pointer;
        display: inline-block;
        /* border: 1px solid #fff; */
        border-radius: 0px;
        align-items: center;
        line-height: 45px;
        margin: 10px 100px;
        width: 110px;
        height: 45px;
        font-size: 20px;
        border: var(--border-green2);
        background-color: var(--background-color-input);
        &:nth-child(2) {
          box-shadow: 0 0 1.5em rgba(188, 230, 236, 0.5) inset;
          background-color: rgb(8, 14, 32);
          // border: $border;
          // background-color: #0f5de5;
          // background: linear-gradient(to bottom right,rgb(229, 229, 130) 0%,rgba(221, 227, 98, 0.404) 36%,rgba(219, 246, 67, 0.4) 72%,rgb(250, 250, 75) 100%);
        }
      }
    }
  }

  .result_nav {
    margin-top: 30px;
    padding-bottom: 10px;
    width: 100%;
    border-bottom: 3px solid var(--font-color-green);
    text-align: center;
    position: relative;
    .result_nav_center {
      font-size: 20px;
      color: var(--font-color-green);
    }
    .result_nav_right {
      position: absolute;
      top: 0;
      right: 10%;
      span {
        color: white;
        font-size: 13px;
        margin-left: 10px;
        cursor: pointer;
        &:nth-child(1),
        &:nth-last-child(1) {
          cursor: text;
        }
      }
    }
    &::before {
      content: "";
      display: block;
      border: 20px solid transparent;
      border-top-color: var(--font-color-green);
      position: absolute;
      left: 49%;
      bottom: -40px;
    }
  }
  .result-content-contianer {
    display: flex;

    .content-info {
      position: sticky;
      top: 0px;
      margin-top: 20px;
      // height: calc(100% - 50px);
      margin-left: 100px;
      width: 35vw;
      max-width: 500px;

      .time-info {
        font-size: 16px;
        display: block;
        text-align: right;
        color: white;
      }

      .text-info {
        margin-top: 10px;
        font-size: 18px;
        display: block;
        text-indent: 2em;
        line-height: 1.5;
        color: white;
      }
    }
  }
  .result_content {
    padding: 10px;
    width: 880px;
    // height: 65vh;
    // overflow-y: scroll;
    // padding: 20px;
    margin: 20px 0;
    // border: 1px solid #fff;
    // border-radius: 10px;
    border:var(--border-green2);
    background-color: var(--background-color-input);
  }
  .result_content > div:not(:last-of-type) {
    margin-bottom: 10px;
    padding: 10px;
    // border: 1px solid #2320204f;
    // border-radius: 10px;
    // background: var(--background-color-active);
    background-color: transparent;
    border: var(--border-green);
  }
  .result_content > div div {
    margin-bottom: 10px;
    font-size: 18px;
  }
  .result_content_list {
    span {color: white;}
  }
}
// .SeniorResultPage_keywords {
//   margin-top: 10px;
//   // border: 1px solid #fff;
//   padding: 10px;
//   padding-bottom: 30px;
//   width: 900px;
// }
// .SeniorResultPage_keywords div {
//   vertical-align: top;
//   text-align: center;
//   line-height: 55px;
//   margin-left: 20px;
//   border: 1px solid #fff;
//   display: inline-block;
//   width: 110px;
//   height: 55px;
// }
// .SeniorResultPage_keywords input {
//   padding-left: 10px;
//   color: #eee;
//   vertical-align: top;
//   border: 1px solid #fff;
//   display: inline-block;
//   width: 600px;
//   height: 55px;
//   /* margin-top: 14px; */
// }

// .seniorSearch {
//   cursor: pointer;
//   border: 1px solid #fff;
//   border-radius: 5px;
//   align-items: center;
//   /* line-height: 55px; */
// }
// .result_nav {
//   margin-top: 10px;
//   width: 900px;
//   display: flex;
//   justify-content: space-between;
// }
// .result_nav_right span {
//   margin-left: 10px;
//   cursor: pointer;
// }
// .result_nav_right span:nth-child(1),
// .result_nav_right span:nth-last-child(1) {
//   cursor: text;
// }
// .result_content {
//   width: 880px;
//   height: 65vh;
//   overflow: scroll;
//   padding: 20px;
//   margin-top: 20px;
//   border: 1px solid #fff;
//   border-radius: 10px;
// }
// .result_content > div {
//   margin-bottom: 20px;
//   padding: 10px;
//   border: 1px solid #eee;
//   border-radius: 10px;
// }
// .result_content > div div {
//   margin-bottom: 10px;
// }
// .result_content_list {
//   /* background-color: rgb(23, 40, 190); */
// }
</style>
